import { render, staticRenderFns } from "./Ranks.vue?vue&type=template&id=33b137e0&scoped=true&"
import script from "./Ranks.vue?vue&type=script&lang=js&"
export * from "./Ranks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b137e0",
  null
  
)

export default component.exports